import { stateNameToFips, countyNameToFips, cleanCountyName } from './fipsUtils';

/**
 * Formats percentage value for display
 * @param {number} value - Decimal value (0-1)
 * @returns {string} Formatted percentage
 */
export const formatPercentage = (value) => {
  if (value === undefined || value === null || isNaN(value)) return 'N/A';
  
  // Check if the value is already in percentage format (greater than 1)
  if (value > 1) {
    return `${Math.round(value * 10) / 10}%`; // Already a percentage, just round to 1 decimal
  } else {
    return `${Math.round(value * 1000) / 10}%`; // Convert from decimal to percentage
  }
};

/**
 * Processes raw county data into standardized format with FIPS codes
 * @param {Array} data - Raw county data
 * @returns {Array} Processed data with FIPS codes
 */
export const processCountyData = (data) => {
  if (!data || data.length === 0) return [];
  
  return data.map(item => {
    // Preserve existing FIPS if valid
    if (item.fips?.match(/^\d{5}$/)) return item;
    
    const stateFips = stateNameToFips[item.stateCode]?.padStart(2, '0') || '00';
    const cleanedName = cleanCountyName(item.countyName || item.countyCode);
    const countyFips = countyNameToFips[cleanedName]?.[stateFips]?.padStart(3, '0') || '000';

    return {
      ...item,
      fips: `${stateFips}${countyFips}`,
      stateFips,
      countyFips
    };
  });
}; 